import './DocumentsAdministratifs.scss';

import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {Outlet, useLocation, useNavigate } from 'react-router-dom';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import useRole from '../../../hooks/useRole';
import useWindowSize from '../../../hooks/useWindowSize';
import { SideBarNavigationFicheExpert } from '../../../Styles/componentStyles';

function DocAdministra({type}) {

    DocAdministra.propTypes = {
        type: PropTypes.any,
    };
    const { i18n } = useTranslation();
    const {pathname} = useLocation();
    const currentPath = pathname.split('/').pop();
    const {device}=useWindowSize();
    const [urlPage,setUrlPage]=useState('');
    const navigate = useNavigate();
    const role=useRole();
    console.log('type type',type);

    useEffect(() => {
        if(pathname){
            setUrlPage(pathname);
        }
    },[pathname]);

    useEffect(() => {
        if(urlPage){
            console.log('urlPage',urlPage);
            console.log('urlPage 2',('/' + ((pathname.split('/')).slice(1, -1)).join('/') + '/DonneeCV'));
        }
    },[urlPage]);

    const handleChangeUrl = async (e) => {
        const newUrl = e.target.value;
        await setUrlPage(newUrl);
        navigate(newUrl, { replace: true });
    };

    return (
        <>
            {device=='desktop' &&
            <div style={SideBarNavigationFicheExpert.frame1SideBarCompteExpert}>
                <div
                    className='DonneePersonnelT'
                    style={
                        (currentPath == 'DonneePersonnel' || currentPath == 'DonneeCV' || currentPath == 'Preference'||currentPath == 'Societe')?
                            SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                    }
                >
                    <p
                        style={
                            (currentPath == 'DonneePersonnel' || currentPath == 'DonneeCV' || currentPath == 'Preference'||currentPath == 'Societe') ?
                                SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                        }
                        onClick={()=>{
                            if(currentPath == 'DonneePersonnel')
                                navigate('.');
                            else
                                navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/DonneePersonnel',{ replace: true });
                        }}

                    >{i18n.t('Données profil')}</p>

                </div>
                {/*si on a Specifie le type ou on a meme pas declarer on doit afficher la petit side bar blanche*/}
                {((type=='Actif' || typeof type=='undefined' )&& role!='esn') &&
                    <div
                        className='DocumentsAdministratifsT'
                        style={
                            (currentPath == 'PieceIdentite' ||currentPath == 'Contrat' || currentPath == 'Kbis'||currentPath == 'Assurance'
                            ||currentPath == 'AttestationHonneur'||currentPath == 'AttestationUrsaf'||currentPath == 'AttestationFiscale') ?
                                SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                        }
                    >

                        <p
                            style={
                                (currentPath == 'PieceIdentite' ||currentPath == 'Contrat' || currentPath == 'Kbis'||currentPath == 'Assurance'
                                ||currentPath == 'AttestationHonneur'||currentPath == 'AttestationUrsaf'||currentPath == 'AttestationFiscale') ?
                                    SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                            }
                            onClick={()=>{
                                navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/PieceIdentite', { replace: true });
                            }}
                        >{i18n.t('Documents administratifs')}</p>
                    </div>
                }
                <div>
                    <Outlet />
                </div>
            </div>
            }
            {device!='desktop' &&
            <div style={{display:'flex',flexDirection:'column',width:'100%'}}>
                <div style={{width:'100%',minWidth:'200px',maxWidth:'500px'}}>
                    <SelectComponent
                        val={urlPage}
                        setVal={(e) => handleChangeUrl(e)}
                        listVal={[
                            {
                                value:( '/' + ((pathname.split('/')).slice(1, -1)).join('/') + '/DonneePersonnel'),
                                label:i18n.t('Données profil'),
                            },
                            {
                                value:
                                ('/' + ((pathname.split('/')).slice(1, -1)).join('/') + '/DonneeCV'),
                                label:i18n.t('Données profil'),
                                hidden:true,
                            },
                            {
                                value:
                                ('/' + ((pathname.split('/')).slice(1, -1)).join('/') + '/Preference'),
                                label:i18n.t('Données profil'),
                                hidden:true,
                            },
                            {
                                value:
                                ('/' + ((pathname.split('/')).slice(1, -1)).join('/') + '/Societe'),
                                label:i18n.t('Données profil'),
                                hidden:true,
                            },
                            {
                                value:'/'+((pathname.split('/')).slice(1,-1)).join('/')+'/PieceIdentite',
                                label:i18n.t('Documents administratifs'),
                                hidden:type=='Actif' ? true:false,
                            } ,
                            {
                                value:'/'+((pathname.split('/')).slice(1,-1)).join('/')+'/kbis',
                                label:i18n.t('Documents administratifs'),
                                hidden:true,
                            } ,
                            {
                                value:'/'+((pathname.split('/')).slice(1,-1)).join('/')+'/AttestationUrsaf',
                                label:i18n.t('Documents administratifs'),
                                hidden:true,
                            } ,
                            {
                                value:'/'+((pathname.split('/')).slice(1,-1)).join('/')+'/Assurance',
                                label:i18n.t('Documents administratifs'),
                                hidden:true,
                            } ,
                            {
                                value:'/'+((pathname.split('/')).slice(1,-1)).join('/')+'/AttestationFiscale',
                                label:i18n.t('Documents administratifs'),
                                hidden:true,
                            } ,
                            {
                                value:'/'+((pathname.split('/')).slice(1,-1)).join('/')+'/Contrat',
                                label:i18n.t('Documents administratifs'),
                                hidden:true,
                            } ,
                            {
                                value:'/'+((pathname.split('/')).slice(1,-1)).join('/')+'/AttestationHonneur',
                                label:i18n.t('Documents administratifs'),
                                hidden:true,
                            } ,

                        ]}
                    />
                </div>
                <div>
                    <Outlet />
                </div>
            </div>
            }
        </>

    );
}

export default DocAdministra;